<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="visible"
      width="700px"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <el-form :model="dataForm" ref="dataForm" :rules="rules" @keyup.enter.native="submitForm()">
        <el-form-item label="用户名" :label-width="formLabelWidth" prop="loginName">
          <el-input
            show-word-limit
            v-model="dataForm.loginName"
            :disabled="type === 2"
            maxlength="25"
            placeholder="请输入用户名，最多25字"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="姓名" :label-width="formLabelWidth" prop="userName">
          <el-input
            show-word-limit
            v-model="dataForm.userName"
            :disabled="type === 2 && isAdmin"
            maxlength="25"
            placeholder="请输入姓名，最多25字"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="登录密码"
          :label-width="formLabelWidth"
          prop="password"
          :required="isHaveTo"
        >
          <el-input
            show-word-limit
            v-model="dataForm.password"
            show-password
            maxlength="25"
            placeholder="请输入密码，最多25字"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="确认密码"
          :label-width="formLabelWidth"
          prop="confirm"
          :required="isHaveTo"
        >
          <el-input
            show-word-limit
            v-model="dataForm.confirm"
            show-password
            maxlength="25"
            placeholder="请再次输入密码，最多25字"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="所属组织" :label-width="formLabelWidth" prop="org">
          <el-input
            show-word-limit
            disabled
            v-model="dataForm.org"
            maxlength="25"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" :label-width="formLabelWidth" prop="remark">
          <el-input
            type="textarea"
            :rows="4"
            maxlength="100"
            placeholder="请输入备注，最多100字"
            show-word-limit
            v-model="dataForm.remark"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm()">取消</el-button>
        <el-button type="primary" @click="submitForm()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (this.type === 1) {
        if (value === '') {
          callback(new Error('请输入登录密码'))
        } else if (value && value.length < 5) {
          callback(new Error('密码字符不得小于5位'))
        } else {
          if (this.dataForm.confirm !== '') {
            this.$refs.dataForm.validateField('confirm')
          }
          callback()
        }
      } else {
        if (value && value.length < 5) {
          callback(new Error('密码字符不得小于5位'))
        } else {
          if (this.dataForm.confirm !== '') {
            this.$refs.dataForm.validateField('confirm')
          }
          callback()
        }
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (this.type === 1) {
        if (value === '') {
          callback(new Error('请再次输入密码'))
        } else if (value !== this.dataForm.password) {
          callback(new Error('两次输入密码不一致!'))
        } else {
          callback()
        }
      } else {
        if (value !== this.dataForm.password) {
          callback(new Error('两次输入密码不一致!'))
        } else {
          callback()
        }
      }
    }
    return {
      type: 1, // 1新增，2编辑
      isAdmin: false,
      visible: false,
      currentUserId: '', // 当前编辑ID
      title: '新增用户',
      isHaveTo: false,
      dataForm: {
        loginName: '',
        userName: '',
        password: '',
        confirm: '',
        org: '本域',
        remark: ''
      },
      formLabelWidth: '120px',
      rules: {
        loginName: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { max: 25, message: '最多25字', trigger: 'blur' }
        ],
        userName: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { max: 25, message: '最多25字', trigger: 'blur' }
        ],
        password: [
          { validator: validatePass, trigger: 'change' },
          { validator: validatePass, trigger: 'blur' }
        ],
        confirm: [
          { validator: validatePass2, trigger: 'change' },
          { validator: validatePass2, trigger: 'blur' }
        ],
        remark: [
          { message: '请输入备注', trigger: 'blur' },
          { max: 100, message: '最多100字', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init(info) {
      this.visible = true
      if (info === '') {
        // 新增
        this.type = 1
        this.title = '新增用户'
        this.isHaveTo = true
        this.$nextTick(() => {
          this.$refs.dataForm.resetFields()
          this.dataForm.loginName = ''
          this.dataForm.userName = ''
          this.dataForm.password = ''
          this.dataForm.confirm = ''
          this.dataForm.remark = ''
        })
      } else {
        // 编辑
        this.title = '修改用户'
        this.type = 2
        this.isHaveTo = false
        this.isAdmin = false
        if (info.perm === 'admin') {
          this.isAdmin = true
        }
        this.$nextTick(() => {
          this.$refs.dataForm.resetFields()
          this.currentUserId = info.id
          this.dataForm.loginName = info.loginName
          this.dataForm.userName = info.userName
          this.dataForm.password = ''
          this.dataForm.confirm = ''
          this.dataForm.remark = info.remark
        })
      }
    },
    resetForm() {
      this.$refs.dataForm.resetFields()
      this.visible = false
    },
    submitForm() {
      this.$refs.dataForm.validate(valid => {
        if (valid) {
          if (this.dataForm.loginName.trim() === '') {
            this.$message.error('用户名不能是空格')
            return
          }
          if (this.dataForm.userName.trim() === '') {
            this.$message.error('姓名不能是空格')
            return
          }
          if (this.type === 1) {
            // 新增
            if (this.dataForm.password.trim() === '') {
              this.$message.error('密码不能是空格')
              return
            }
            if (this.dataForm.confirm.trim() === '') {
              this.$message.error('确认密码不能是空格')
              return
            }
            this.add()
          } else {
            // 编辑
            this.update()
          }
        } else {
          return false
        }
      })
    },
    // 新增
    add() {
      this.$http({
        url: this.$http.adornUrl('/api/edit/addUser'),
        method: 'post',
        params: this.$http.adornParams({
          loginName: this.dataForm.loginName.trim(),
          userName: this.dataForm.userName.trim(),
          password: this.dataForm.password.trim(),
          confirm: this.dataForm.confirm.trim(),
          remark: this.dataForm.remark.trim()
        })
      }).then(res => {
        if (res.resp_code === 0) {
          this.visible = false
          this.$emit('refreshDataList')
          this.$message({
            message: '添加成功',
            type: 'success'
          })
        } else {
          this.$message.error(res.resp_msg)
        }
      })
    },
    // 编辑
    update() {
      this.$http({
        url: this.$http.adornUrl('/api/edit/updateUser'),
        method: 'post',
        params: this.$http.adornParams({
          uid: this.currentUserId,
          loginName: this.dataForm.loginName.trim(),
          userName: this.dataForm.userName.trim(),
          password: this.dataForm.password ? this.dataForm.password.trim() : '',
          confirm: this.dataForm.confirm ? this.dataForm.confirm.trim() : '',
          remark: this.dataForm.remark.trim()
        })
      }).then(res => {
        if (res.resp_code === 0) {
          this.visible = false
          this.$emit('refreshDataList')
          this.$message({
            message: '修改成功',
            type: 'success'
          })
        } else {
          this.$message.error(res.resp_msg)
        }
      })
    }
  }
}
</script>
